/**
 * @private
 * Test for a string representing a boolean `true`
 */
const TRUE = /true/;

/**
 * @public
 * The environment values are generated from Webpack.
 * They are read from the variable `NODE_ENV`.
 *
 * @see webpack/replacements.js
 */
const settings = {
  version: '2.186.0',
  isProd: TRUE.test('true'),
  isStg: TRUE.test('#{isStg}'),
  isDev: TRUE.test('false'),
  isQa: TRUE.test('#{isQa}'),
  defaults: {
    timeFormat: 'HH:mm',
    dateFormat: 'MM/dd/yyyy',
  },
};

/**
 * This hack is because AppVeyor is agnostic to staging
 * or production environments, then Octopus must pick out
 * the staging environment and override the `isProd` flag.
 * Files to seek: hc-*.js
 */
if (TRUE.test('#{STG_OVERRIDE}')) {
  settings.isProd = false;
  settings.isStg = true;
}

if (TRUE.test('#{IS_QA}')) {
  settings.isQa = true;
}

settings.subDomain = settings.isProd ? '' : '.stg';
settings.subDomainWithQA = (settings.isDev || settings.isQa) ? '.qa' : settings.subDomain;


export default settings;
